

/**
 *  SelectBox에 해당하는 옵션을 넣기위해 사용하는
 *  공통 데이터입니다.
 *  *  codeKey : 선택하면 나오는 value값
 *  codeValue: selectBox에 나오는 옵션 설명
 *
 */


//장치 목록에서 사용하는 옵션입니다.
const DEVICE_LIST={
    USE_YN:[
        {codeValue: '사용', codeKey: 'Y'},
        {codeValue: '미사용', codeKey: 'N'},
    ],
    DELETE_YN:[
        {codeValue: '삭제', codeKey: 'Y'},
        {codeValue: '미삭제', codeKey: 'N'},
    ],
    DEVICE_TYPE:[
        {codeValue: '(구)PC에이전트', codeKey: 'PC'},
        {codeValue: '(신)PC에이전트', codeKey: 'PS'},
        {codeValue: '고객에이전트', codeKey: 'CS'},
        {codeValue: 'CUBE', codeKey: 'DV'},
        {codeValue: '수동', codeKey: 'MA'},

    ],
    INSTALL_STATUS:[
        {codeValue: '거래처 연결됨 ', codeKey: "Y"},
        {codeValue: '거래처 연결안됨 ', codeKey: "N"},
    ],

}

//장치 상세에서 사용하는 옵션입니다.
const DEVICE_DETAIL = {
    CMD_OPTIONS:[
        {codeValue: '프린터 헤드 정렬 [1]', codeKey: 1,validateCheckData:[
                'monitoringPrinterId','serialNo','modelName']},
        {codeValue: '프린터 헤드 청소 [2]', codeKey: 2,validateCheckData:[
                'monitoringPrinterId','serialNo','modelName']},
        {codeValue: '프린터 라인 피드 [3]', codeKey: 3,validateCheckData:[
                'monitoringPrinterId','serialNo','modelName']},
        {codeValue: '테스트 페이지 출력 [4]', codeKey: 4,validateCheckData:[
                'monitoringPrinterId','serialNo','modelName']},
        {codeValue: '프린터 재 시작 [6]', codeKey: 6},
        {codeValue: '프린터 등록 [100]', codeKey: 100,validateCheckData:[
                'serialNo','modelName','ip']},
        {codeValue: '프린터 삭제 [101]', codeKey: 101,validateCheckData:[
                'serialNo','modelName','ip']},
        {codeValue: '프린터 등록 목록 동기화 [105]', codeKey: 105},
        {codeValue: '프린터 enable [302]', codeKey: 302,validateCheckData:[
                'monitoringPrinterId','serialNo','modelName']},
        {codeValue: '프린터 disable [303]', codeKey: 303,validateCheckData:[
                'monitoringPrinterId','serialNo','modelName']},
        {codeValue: '프린터 검색 [304]', codeKey: 304},
        {codeValue: '장치 설정 정보 가져오기 [401]', codeKey: 401},
        {codeValue: '장치 설정 정보 저장 [402]', codeKey: 402},
        {codeValue: '장치 모니터링 로그 가져오기 [411]', codeKey: 411},
        {codeValue: '장치 업데이트 로그 가져오기 [412]', codeKey: 412},
        {codeValue: '장치 APP LOG 가져오기 [413]', codeKey: 413},
        {codeValue: 'SNMP 원격 수집 [901]', codeKey: 901,validateCheckData:[
                'serialNo','modelName', 'ip']},
    ],
}

const DEPOSIT_LIST = {
    BASE_SEARCH_DATA_TYPE_OPTIONS: [
        {codeValue: '출금요청일', codeKey: 'R'},
        {codeValue: '정산일', codeKey: 'S'},
        {codeValue: '출금일', codeKey: 'W'},
    ],
    PAYMENT_STATUS_LIST_OPTIONS: [
        {codeValue: 'CMS카드', codeKey: 'C'},
        {codeValue: 'CMS이체', codeKey: 'B'},
        {codeValue: '기타수납', codeKey: 'E'},
    ]
}
//배치에서 사용하는 옵션입니다.
const BATCH ={
    DUPLICATE_SALES_SHOW:[
        {codeValue: '전체 목록 보기', codeKey: 'T'},
        {codeValue: '예상건수와 생성건수가 다른 목록 보기', codeKey: 'D'},
    ],
    BATCH_OPTIONS: [
            {codeValue: '배치 종료 여부', codeKey: 'F'},
            {codeValue: '중복 매출', codeKey: 'B'},
            {codeValue: '누락 매출', codeKey: 'BO'},
            {codeValue: '세금계산서', codeKey: 'T'},
            {codeValue: '세금계산서 입금 후 발행', codeKey: 'TA'},
            {codeValue: '누락 CMS', codeKey: 'C'},
            {codeValue: '중복 CMS', codeKey: 'CD'},
            {codeValue: '월별사용량', codeKey: 'M'},
            {codeValue: '일별사용량 에러', codeKey: 'P'},
            {codeValue: '실패 목록', codeKey: 'FL'},
            // {codeValue: '월별 사용량', codeKey: 'US'},
    ]
}


export default {
    DEVICE_LIST,
    DEVICE_DETAIL,
    DEPOSIT_LIST,
    BATCH
}